// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__3sYsU","Div":"CustomFadeBox_Div__6bAiI","LargeDiv":"CustomFadeBox_LargeDiv__3z2bl"};